import { IconViewOutline } from '@featuring-corp/icons';
import { sprinkles } from '@styles/vanilla-extract/sprinkles.css';
import { disabledAnchor, ellipsisLine } from '@styles/vanilla-extract/utils';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import clsx from 'clsx';
import React from 'react';

import round from '@utils/round';

import { Link } from 'react-router-dom';

import CoreImg from '@shared/CoreImg';

import {
	containerClass,
	imgContainerClass,
	imgContentClass,
	paidAdTagClass,
	textClass,
	textContainerClass,
	textContentClass,
	textContentItemClass,
} from './style.css';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface ShortVideoContentItemProps {
	outLink?: string;
	imgSrc?: string;
	viewCount?: number;
	contentText?: string;
	idx?: number;
	isPaidAd?: boolean;
	music?: string;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const ShortVideoContentItem = ({
	idx = 0,
	isPaidAd,
	music,
	isLoading,
	isError,
	lackOfPermission,
	...props
}: ShortVideoContentItemProps) => {
	const available = !isLoading && !isError && !lackOfPermission;
	const outLink = !available ? '' : props.outLink;
	const imgSrc = isError
		? 'public/images/report/no-image.png'
		: lackOfPermission
		? `https://source.unsplash.com/random?${idx}`
		: props.imgSrc;

	const viewCount =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '00'
			: props.viewCount
			? round(props.viewCount, 'down')
			: '-';
	const contentText =
		isLoading || isError
			? '-'
			: lackOfPermission
			? '에시 텍스트입니다.'
			: props.contentText ?? '-';

	return (
		<CustomLink
			href={outLink ?? ''}
			target={'_blank'}
			className={disabledAnchor}
			aria-disabled={!available}
		>
			<div className={containerClass}>
				<div className={imgContainerClass}>
					<div className={imgContentClass}>
						<CoreImg
							src={imgSrc ?? ''}
							alt="feed-content-image"
							is_loading={isLoading}
							object_fit="contain"
						/>
					</div>
					{isPaidAd && <div className={paidAdTagClass}>유료 광고 포함</div>}
				</div>

				<div className={textContainerClass}>
					<div
						className={textContentClass}
						style={assignInlineVars({ [ellipsisLine]: music ? '1' : '2' })}
					>
						{!music && contentText}
						{music && (
							<>
								<p className={clsx(sprinkles({ color: 'text-2' }), textContentItemClass)}>
									{contentText}
								</p>
								<p className={textContentItemClass}>♪ {music}</p>
							</>
						)}
					</div>
					<div className={textClass}>
						<IconViewOutline />
						{viewCount} 회
					</div>
				</div>
			</div>
		</CustomLink>
	);
};

export default ShortVideoContentItem;
